var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "fa-wizard" },
    [
      _c(
        "div",
        { staticClass: "fa-body" },
        [
          _c(
            "aside",
            { staticClass: "fa-steps" },
            _vm._l(_vm.steps, function (s, i) {
              return _c(
                "div",
                {
                  key: s.key,
                  staticClass: "fa-step",
                  class: {
                    active: _vm.step == i,
                    done: i < _vm.step,
                    invalid: !_vm.stepValid(i) && i < _vm.step,
                  },
                  on: {
                    click: function ($event) {
                      _vm.step = i
                    },
                  },
                },
                [
                  _c(
                    "span",
                    { staticClass: "fa-step-num" },
                    [
                      i < _vm.step && _vm.stepValid(i)
                        ? _c("w-fa", { attrs: { icon: "check" } })
                        : [_vm._v(_vm._s(i + 1))],
                    ],
                    2
                  ),
                  _c("span", { staticClass: "fa-step-text" }, [
                    _c("span", { staticClass: "fa-step-title" }, [
                      _vm._v(_vm._s(s.title)),
                    ]),
                    _c("span", { staticClass: "fa-step-hint" }, [
                      _vm._v(_vm._s(s.hint)),
                    ]),
                  ]),
                ]
              )
            }),
            0
          ),
          _c(
            "w-scroll-view",
            { staticClass: "fa-content", attrs: { tag: "div" } },
            [
              _vm.step == 0
                ? _c(
                    "div",
                    { staticClass: "fa-panel" },
                    [
                      _c("h2", { staticClass: "fa-panel-title" }, [
                        _vm._v(_vm._s(_vm.$ct("wizard.purchase-title"))),
                      ]),
                      _c("p", { staticClass: "fa-panel-info" }, [
                        _vm._v(_vm._s(_vm.$ct("wizard.purchase-info"))),
                      ]),
                      _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-select", {
                                attrs: {
                                  fancy: "",
                                  items: _vm.purchaseItems,
                                  label: _vm.$ct("purchase-83"),
                                },
                                model: {
                                  value: _vm.selectedPurchaseIndex,
                                  callback: function ($$v) {
                                    _vm.selectedPurchaseIndex = $$v
                                  },
                                  expression: "selectedPurchaseIndex",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12", md: "6" } },
                            [
                              _c("w-input", {
                                attrs: { fancy: "", label: _vm.$ct("name") },
                                model: {
                                  value: _vm.asset.Name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.asset, "Name", $$v)
                                  },
                                  expression: "asset.Name",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12", md: "6" } },
                            [
                              _c("app-contact-search", {
                                attrs: {
                                  "group-id": [2],
                                  "disable-create": "",
                                  fancy: "",
                                  label: _vm.$ct("supplier"),
                                },
                                model: {
                                  value: _vm.contact,
                                  callback: function ($$v) {
                                    _vm.contact = $$v
                                  },
                                  expression: "contact",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-input", {
                                attrs: {
                                  fancy: "",
                                  label: _vm.$ct("description"),
                                },
                                model: {
                                  value: _vm.asset.Description,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.asset, "Description", $$v)
                                  },
                                  expression: "asset.Description",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      !_vm.asset.Name
                        ? _c("w-info", {
                            attrs: {
                              tiny: "",
                              text: _vm.$ct("wizard.missing-name"),
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.step == 1
                ? _c(
                    "div",
                    { staticClass: "fa-panel" },
                    [
                      _c("h2", { staticClass: "fa-panel-title" }, [
                        _vm._v(_vm._s(_vm.$ct("wizard.values-title"))),
                      ]),
                      _c("p", { staticClass: "fa-panel-info" }, [
                        _vm._v(_vm._s(_vm.$ct("wizard.values-info"))),
                      ]),
                      _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            { attrs: { xs: "6", md: "3" } },
                            [
                              _c("w-date-picker", {
                                attrs: {
                                  fancy: "",
                                  label: _vm.$ct("start-date"),
                                },
                                model: {
                                  value: _vm.asset.StartDate,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.asset, "StartDate", $$v)
                                  },
                                  expression: "asset.StartDate",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "6", md: "3" } },
                            [
                              _c("w-input-number", {
                                attrs: {
                                  fancy: "",
                                  decimals: 2,
                                  label: _vm.$ct("acquisition-value"),
                                },
                                model: {
                                  value: _vm.asset.AcquisitionValue,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.asset, "AcquisitionValue", $$v)
                                  },
                                  expression: "asset.AcquisitionValue",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "6", md: "3" } },
                            [
                              _c("w-input-number", {
                                attrs: {
                                  fancy: "",
                                  decimals: 2,
                                  label: _vm.$ct("residual-value"),
                                },
                                model: {
                                  value: _vm.asset.ResidualValue,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.asset, "ResidualValue", $$v)
                                  },
                                  expression: "asset.ResidualValue",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "6", md: "3" } },
                            [
                              _c("w-input-number", {
                                attrs: {
                                  fancy: "",
                                  decimals: 0,
                                  label: _vm.$ct("years"),
                                },
                                model: {
                                  value: _vm.asset.Years,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.asset, "Years", $$v)
                                  },
                                  expression: "asset.Years",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("h3", { staticClass: "fa-group-title" }, [
                        _vm._v(_vm._s(_vm.$ct("wizard.method-title"))),
                      ]),
                      _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            { attrs: { xs: "12", md: "4" } },
                            [
                              _c("w-select", {
                                attrs: {
                                  fancy: "",
                                  items: _vm.methodItems,
                                  label: _vm.$ct("method"),
                                },
                                model: {
                                  value: _vm.asset.Method,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.asset, "Method", $$v)
                                  },
                                  expression: "asset.Method",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12", md: "8" } },
                            [
                              _c("w-info", {
                                attrs: {
                                  tiny: "",
                                  text: _vm.$ct(
                                    `wizard.method-info.${_vm.asset.Method}`
                                  ),
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12", md: "4" } },
                            [
                              _c("w-select", {
                                attrs: {
                                  fancy: "",
                                  items: _vm.proRataItems,
                                  disabled: _vm.asset.Method != "linear",
                                  label: _vm.$ct("pro-rata"),
                                },
                                model: {
                                  value: _vm.asset.ProRataMode,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.asset, "ProRataMode", $$v)
                                  },
                                  expression: "asset.ProRataMode",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm.asset.ProRataMode == "percent" &&
                          _vm.asset.Method == "linear"
                            ? _c(
                                "w-col",
                                { attrs: { xs: "12", md: "3" } },
                                [
                                  _c("w-input-number", {
                                    attrs: {
                                      fancy: "",
                                      decimals: 2,
                                      label: _vm.$ct("pro-rata-percent"),
                                    },
                                    model: {
                                      value: _vm.asset.ProRataPercent,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.asset,
                                          "ProRataPercent",
                                          $$v
                                        )
                                      },
                                      expression: "asset.ProRataPercent",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c("w-col", { attrs: { xs: "12" } }, [
                            _c("p", { staticClass: "fa-field-info" }, [
                              _vm._v(_vm._s(_vm.$ct("wizard.pro-rata-info"))),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _c("h3", { staticClass: "fa-group-title" }, [
                        _vm._v(_vm._s(_vm.$ct("wizard.history-title"))),
                      ]),
                      _c("p", { staticClass: "fa-field-info" }, [
                        _vm._v(_vm._s(_vm.$ct("wizard.first-bookyear-info"))),
                      ]),
                      _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            { attrs: { xs: "12", md: "4" } },
                            [
                              _c("w-select", {
                                attrs: {
                                  fancy: "",
                                  items: _vm.bookYearItems,
                                  label: _vm.$ct("first-bookyear"),
                                },
                                model: {
                                  value: _vm.asset.FirstBookYear,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.asset, "FirstBookYear", $$v)
                                  },
                                  expression: "asset.FirstBookYear",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm.asset.FirstBookYear != 0
                            ? _c(
                                "w-col",
                                { attrs: { xs: "12", md: "4" } },
                                [
                                  _c("w-input-number", {
                                    attrs: {
                                      fancy: "",
                                      decimals: 2,
                                      label: _vm.$ct("already-depreciated"),
                                    },
                                    model: {
                                      value: _vm.asset.AlreadyDepreciated,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.asset,
                                          "AlreadyDepreciated",
                                          $$v
                                        )
                                      },
                                      expression: "asset.AlreadyDepreciated",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.step == 2
                ? _c(
                    "div",
                    { staticClass: "fa-panel" },
                    [
                      _c("h2", { staticClass: "fa-panel-title" }, [
                        _vm._v(_vm._s(_vm.$ct("wizard.ledgers-title"))),
                      ]),
                      _c("p", { staticClass: "fa-panel-info" }, [
                        _vm._v(_vm._s(_vm.$ct("wizard.ledgers-info"))),
                      ]),
                      _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            { attrs: { xs: "12", md: "4" } },
                            [
                              _vm.hasPurchase &&
                              _vm.purchaseInvestmentLedgers.length > 0
                                ? [
                                    _c("w-select", {
                                      attrs: {
                                        value: _vm.asset.AssetLedgerCode,
                                        fancy: "",
                                        items: _vm.investmentLedgerItems,
                                        label: _vm.$ct(
                                          "asset-ledger-from-purchase"
                                        ),
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.onInvestmentLedgerSelect(
                                            $event
                                          )
                                        },
                                      },
                                    }),
                                    _c("p", { staticClass: "fa-field-info" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$ct(
                                            "wizard.asset-ledger-from-purchase-info"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                : [
                                    _c("app-ledger-account-autocomplete", {
                                      attrs: {
                                        fancy: "",
                                        label: _vm.$ct("asset-ledger"),
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.onAssetLedgerInput($event)
                                        },
                                      },
                                      model: {
                                        value: _vm.asset.AssetLedgerCode,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.asset,
                                            "AssetLedgerCode",
                                            $$v
                                          )
                                        },
                                        expression: "asset.AssetLedgerCode",
                                      },
                                    }),
                                    _c("p", { staticClass: "fa-field-info" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$ct("wizard.asset-ledger-info")
                                        )
                                      ),
                                    ]),
                                  ],
                            ],
                            2
                          ),
                          _vm.hasPurchase &&
                          _vm.purchaseInvestmentLedgers.length == 0
                            ? _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("w-info", {
                                    attrs: {
                                      tiny: "",
                                      text: _vm.$ct(
                                        "wizard.no-investment-ledger-warning"
                                      ),
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "w-col",
                            { attrs: { xs: "12", md: "4" } },
                            [
                              _c("app-ledger-account-autocomplete", {
                                attrs: {
                                  fancy: "",
                                  label: _vm.$ct("depreciation-ledger"),
                                },
                                model: {
                                  value: _vm.asset.DepreciationLedgerCode,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.asset,
                                      "DepreciationLedgerCode",
                                      $$v
                                    )
                                  },
                                  expression: "asset.DepreciationLedgerCode",
                                },
                              }),
                              _c("p", { staticClass: "fa-field-info" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$ct("wizard.depreciation-ledger-info")
                                  )
                                ),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12", md: "4" } },
                            [
                              _c("app-ledger-account-autocomplete", {
                                attrs: {
                                  fancy: "",
                                  label: _vm.$ct("cost-ledger"),
                                },
                                model: {
                                  value: _vm.asset.CostLedgerCode,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.asset, "CostLedgerCode", $$v)
                                  },
                                  expression: "asset.CostLedgerCode",
                                },
                              }),
                              _c("p", { staticClass: "fa-field-info" }, [
                                _vm._v(
                                  _vm._s(_vm.$ct("wizard.cost-ledger-info"))
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.asset.Years > 0 &&
                      (!_vm.asset.DepreciationLedgerCode ||
                        !_vm.asset.CostLedgerCode)
                        ? _c("w-info", {
                            attrs: {
                              tiny: "",
                              text: _vm.$ct("wizard.missing-ledgers"),
                            },
                          })
                        : _vm._e(),
                      _c("h3", { staticClass: "fa-group-title" }, [
                        _vm._v(_vm._s(_vm.$ct("wizard.journal-title"))),
                      ]),
                      _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            { attrs: { xs: "12", md: "4" } },
                            [
                              _c("app-select-journal", {
                                attrs: {
                                  fancy: "",
                                  "no-journal-option": "",
                                  "no-journal-option-label":
                                    _vm.$ct("default-journal"),
                                  label: _vm.$ct("journal"),
                                },
                                model: {
                                  value: _vm.asset.JournalID,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.asset, "JournalID", $$v)
                                  },
                                  expression: "asset.JournalID",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12", md: "8" } },
                            [
                              _c("w-input", {
                                attrs: { fancy: "", label: _vm.$ct("comment") },
                                model: {
                                  value: _vm.asset.Comment,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.asset, "Comment", $$v)
                                  },
                                  expression: "asset.Comment",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("h3", { staticClass: "fa-group-title" }, [
                        _vm._v(_vm._s(_vm.$ct("wizard.status-title"))),
                      ]),
                      _c("p", { staticClass: "fa-field-info" }, [
                        _vm._v(_vm._s(_vm.$ct("wizard.disposed-info"))),
                      ]),
                      _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            { attrs: { xs: "12", md: "4" } },
                            [
                              _c("w-checkbox", {
                                attrs: { label: _vm.$ct("disposed") },
                                model: {
                                  value: _vm.isDisposed,
                                  callback: function ($$v) {
                                    _vm.isDisposed = $$v
                                  },
                                  expression: "isDisposed",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm.isDisposed
                            ? _c(
                                "w-col",
                                { attrs: { xs: "12", md: "4" } },
                                [
                                  _c("w-date-picker", {
                                    attrs: {
                                      fancy: "",
                                      label: _vm.$ct("disposed-at"),
                                    },
                                    model: {
                                      value: _vm.disposedAt,
                                      callback: function ($$v) {
                                        _vm.disposedAt = $$v
                                      },
                                      expression: "disposedAt",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.step == 3
                ? _c(
                    "div",
                    { staticClass: "fa-panel" },
                    [
                      _c("h2", { staticClass: "fa-panel-title" }, [
                        _vm._v(_vm._s(_vm.$ct("wizard.review-title"))),
                      ]),
                      _c("p", { staticClass: "fa-panel-info" }, [
                        _vm._v(_vm._s(_vm.$ct("wizard.review-info"))),
                      ]),
                      _c("div", { staticClass: "fa-summary" }, [
                        _c("div", { staticClass: "fa-summary-item" }, [
                          _c("div", { staticClass: "fa-summary-label" }, [
                            _vm._v(_vm._s(_vm.$ct("name"))),
                          ]),
                          _c("div", { staticClass: "fa-summary-value" }, [
                            _vm._v(_vm._s(_vm.asset.Name || "—")),
                          ]),
                        ]),
                        _c("div", { staticClass: "fa-summary-item" }, [
                          _c("div", { staticClass: "fa-summary-label" }, [
                            _vm._v(_vm._s(_vm.$ct("method"))),
                          ]),
                          _c("div", { staticClass: "fa-summary-value" }, [
                            _vm._v(
                              _vm._s(_vm.$ct(`methods.${_vm.asset.Method}`)) +
                                " · " +
                                _vm._s(
                                  _vm.$ct("years-short", {
                                    years: _vm.asset.Years,
                                  })
                                )
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "fa-summary-item" }, [
                          _c("div", { staticClass: "fa-summary-label" }, [
                            _vm._v(_vm._s(_vm.$ct("wizard.summary-total"))),
                          ]),
                          _c("div", { staticClass: "fa-summary-value" }, [
                            _vm._v(
                              _vm._s(
                                _vm.printHumanFloat(
                                  _vm.asset.AcquisitionValue -
                                    _vm.asset.ResidualValue
                                )
                              )
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "fa-summary-item" }, [
                          _c("div", { staticClass: "fa-summary-label" }, [
                            _vm._v(_vm._s(_vm.$ct("wizard.summary-periods"))),
                          ]),
                          _c("div", { staticClass: "fa-summary-value" }, [
                            _vm._v(_vm._s(_vm.schedule.length)),
                          ]),
                        ]),
                        _c("div", { staticClass: "fa-summary-item" }, [
                          _c("div", { staticClass: "fa-summary-label" }, [
                            _vm._v(_vm._s(_vm.$ct("wizard.summary-first"))),
                          ]),
                          _c("div", { staticClass: "fa-summary-value" }, [
                            _vm._v(
                              _vm._s(
                                _vm.firstPeriod
                                  ? _vm.printLocalDate(_vm.firstPeriod.Date)
                                  : "—"
                              )
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "fa-summary-item" }, [
                          _c("div", { staticClass: "fa-summary-label" }, [
                            _vm._v(_vm._s(_vm.$ct("wizard.summary-last"))),
                          ]),
                          _c("div", { staticClass: "fa-summary-value" }, [
                            _vm._v(
                              _vm._s(
                                _vm.lastPeriod
                                  ? _vm.printLocalDate(_vm.lastPeriod.Date)
                                  : "—"
                              )
                            ),
                          ]),
                        ]),
                      ]),
                      _c("h3", { staticClass: "fa-group-title" }, [
                        _vm._v(_vm._s(_vm.$ct("schedule"))),
                      ]),
                      _vm.schedule.length == 0
                        ? _c("div", { staticClass: "fa-schedule-empty" }, [
                            _vm._v(_vm._s(_vm.$ct("schedule-empty"))),
                          ])
                        : _c(
                            "app-custom-table",
                            { staticClass: "fa-schedule" },
                            [
                              _c("thead", [
                                _c("tr", [
                                  _c("th", { attrs: { width: "90" } }, [
                                    _vm._v(_vm._s(_vm.$ct("bookyear"))),
                                  ]),
                                  _c("th", { attrs: { width: "90" } }, [
                                    _vm._v(_vm._s(_vm.$ct("period"))),
                                  ]),
                                  _c("th", { attrs: { width: "110" } }, [
                                    _vm._v(_vm._s(_vm.$ct("date"))),
                                  ]),
                                  _c("th", { staticClass: "right" }, [
                                    _vm._v(_vm._s(_vm.$ct("amount"))),
                                  ]),
                                  _c("th", { staticClass: "right" }, [
                                    _vm._v(_vm._s(_vm.$ct("cumulative"))),
                                  ]),
                                  _c("th", { staticClass: "right" }, [
                                    _vm._v(_vm._s(_vm.$ct("book-value"))),
                                  ]),
                                  _c("th", { attrs: { width: "130" } }, [
                                    _vm._v(_vm._s(_vm.$ct("status"))),
                                  ]),
                                ]),
                              ]),
                              _c(
                                "tbody",
                                _vm._l(_vm.schedule, function (p, i) {
                                  return _c("tr", { key: i }, [
                                    _c("td", [_vm._v(_vm._s(p.BookYear))]),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          p.Index == 0
                                            ? _vm.$ct("period-year")
                                            : p.Index
                                        )
                                      ),
                                    ]),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(_vm.printLocalDate(p.Date))
                                      ),
                                    ]),
                                    _c("td", { staticClass: "right fa-num" }, [
                                      _vm._v(
                                        _vm._s(_vm.printHumanFloat(p.Amount))
                                      ),
                                    ]),
                                    _c("td", { staticClass: "right fa-num" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.printHumanFloat(p.Cumulative)
                                        )
                                      ),
                                    ]),
                                    _c("td", { staticClass: "right fa-num" }, [
                                      _vm._v(
                                        _vm._s(_vm.printHumanFloat(p.BookValue))
                                      ),
                                    ]),
                                    _c("td", [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "fa-chip",
                                          class: _vm.periodClass(p),
                                        },
                                        [_vm._v(_vm._s(_vm.periodStatus(p)))]
                                      ),
                                    ]),
                                  ])
                                }),
                                0
                              ),
                            ]
                          ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.cancel")) + " ")]
          ),
          _vm.asset.ID
            ? _c(
                "w-button",
                {
                  staticClass: "danger ml",
                  attrs: { icon: "trash", disabled: _vm.isSaving },
                  on: {
                    click: function ($event) {
                      return _vm.remove()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$ct("common.delete")) + " ")]
              )
            : _vm._e(),
          _c("w-spacer"),
          _vm.step == _vm.lastStep
            ? _c("w-checkbox", {
                staticClass: "mr",
                attrs: {
                  label: _vm.$ct("book-now", { bookYear: _vm.bookYear }),
                },
                model: {
                  value: _vm.bookNow,
                  callback: function ($$v) {
                    _vm.bookNow = $$v
                  },
                  expression: "bookNow",
                },
              })
            : _vm._e(),
          _vm.step > 0
            ? _c(
                "w-button",
                {
                  staticClass: "mr",
                  attrs: { icon: "arrow-left" },
                  on: {
                    click: function ($event) {
                      _vm.step--
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$ct("wizard.previous")) + " ")]
              )
            : _vm._e(),
          _vm.step < _vm.lastStep
            ? _c(
                "w-button",
                {
                  attrs: {
                    icon: "arrow-right",
                    disabled: !_vm.stepValid(_vm.step),
                  },
                  on: {
                    click: function ($event) {
                      _vm.step++
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$ct("wizard.next")) + " ")]
              )
            : _c(
                "w-button",
                {
                  attrs: {
                    icon: "check",
                    disabled: !_vm.canSave || _vm.isSaving,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$ct("common.save")) + " ")]
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }